<template>
  <div class="invoice-dialog">
    <el-dialog
      v-model="showLayoutDialog"
      class="dialog-primary"
      :show-close="false"
      :title="aboutInvoice.isPass ? '' : props.type == '1' ? '开具发票' : '发票详情'"
      :close-on-click-modal="false"
      @close="cancelHandle"
    >
      <div class="close_icon" @click="cancelHandle">
        <svg-icon name="Close"></svg-icon>
      </div>
      <div
        v-loading="aboutInvoice.loading"
        element-loading-text="信息获取中，请稍等..."
        class="draw_invoice"
        v-if="!aboutInvoice.isPass"
      >
        <div class="dialog_container">
          <ul class="dialog_tab">
            <template v-for="item in invoiceType.options" :key="item.value">
              <li v-if="item.isShow" @click="selectInvoiceType(item)">
                <div :class="['select', { selected: item.value == invoiceType.value }]"></div>
                <span>{{ item.label }}</span>
              </li>
            </template>
          </ul>
          <div class="dialog_part">
            <div class="main_title">
              <span>开票信息</span>
              <span v-show="invoiceType.value == 1" class="tip"
                >企业类型：增值税一般纳税人，拥有资质证明</span
              >
            </div>
            <ul class="main_part1">
              <li v-if="invoiceType.value == 0">
                <div class="part_title"><span class="essential">*</span>抬头类型：</div>
                <ul class="part_selected">
                  <template v-for="item in invoiceHeadType.options" :key="item.value">
                    <li v-if="item.isShow" @click="selectInvoiceHeadType(item)">
                      <div
                        :class="['select', { selected: item.value == invoiceHeadType.value }]"
                      ></div>
                      <span>{{ item.label }}</span>
                    </li>
                  </template>
                </ul>
              </li>
              <template v-for="item in required" :key="item.id">
                <li v-if="item.isShow">
                  <div class="part_title"><span class="essential">*</span>{{ item.title }}：</div>
                  <el-input
                    v-model="item.value"
                    :class="['part_input']"
                    :readonly="props.type == '2'"
                    :placeholder="props.type == '1' ? item.placeholderTxt : ''"
                  />
                </li>
              </template>
              <template v-if="invoiceType.value == 0">
                <template v-for="item in generalTicket" :key="item.id">
                  <li v-if="item.isShow">
                    <div class="part_title">{{ item.title }}：</div>
                    <el-input
                      v-model="item.value"
                      :class="['part_input']"
                      :readonly="props.type == '2'"
                      :placeholder="props.type == '1' ? item.placeholderTxt : ''"
                    />
                  </li>
                </template>
              </template>
            </ul>
          </div>
          <div
            v-if="invoiceType.value == 1 && props.orderType == 1"
            class="dialog_part dialog_more-info"
          >
            <div
              :class="['main_title', { rotateSvg: aboutSpecial.show }]"
              @click="aboutSpecial.show = !aboutSpecial.show"
            >
              <span>{{ aboutSpecial.txt }}</span>
              <svg-icon name="Arrow-Down3"></svg-icon>
            </div>
            <ul v-show="aboutSpecial.show" class="main_part1">
              <template v-for="item in specialTicket" :key="item.id">
                <li v-if="item.isShow">
                  <div class="part_title">
                    <span v-show="item.beRequired" class="essential">*</span>{{ item.title }}：
                  </div>
                  <el-input
                    v-model="item.value"
                    :class="['part_input']"
                    :readonly="props.type == '2'"
                    :placeholder="props.type == '1' ? item.placeholderTxt : ''"
                  />
                </li>
              </template>
            </ul>
          </div>
          <div class="dialog_part dialog_part2">
            <div class="main_title">收件信息</div>
            <ul class="main_part1">
              <li>
                <div class="part_title"><span class="essential">*</span>邮箱：</div>
                <el-input
                  v-model="receiveEamil"
                  class="part_input"
                  :readonly="props.type == '2'"
                  :placeholder="props.type == '1' ? '必填，请填写邮箱' : ''"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="invoice_is_pass" v-else>
        <svg-icon name="Invoice-Success"></svg-icon>
        <div class="main_title">恭喜你，发票提交成功!</div>
        <div class="intro">注:发票将于5个工作日内开出</div>
        <div class="back_home" @click="cancelHandle">关闭</div>
      </div>
      <template #footer v-if="props.type == '1' && !aboutInvoice.isPass">
        <div class="dialog-footer">
          <el-button @click="cancelHandle">取消</el-button>
          <el-button :class="{ 'is-disabled': !couldInvoice }" type="primary" @click="toOpenInvoice"
            >提交</el-button
          >
        </div>
      </template>
    </el-dialog>

    <el-dialog v-model="makeSure.show" class="make_sure" :align-center="true">
      <div class="dialog_contain">
        <div class="main_title">
          <svg-icon name="Icon-Warning2" size="24px"></svg-icon>
          <span>确认信息</span>
        </div>
        <div class="main_part">
          请务必确保所填发票信息及发票票种{{
            invoiceType.value === 0 ? '（普通发票）' : '（专用发票）'
          }}准确无误，发票一经开具将不予重开！
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="makeSureCancel()">返回修改</el-button>
          <el-button type="primary" @click="makeSureConfirm()">确认</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { apiOrderSeeDetail, apiUserInvoice } from '@/api/modules/cad_api'
import { apiUserInvoice as specialApiInvoice } from '@/api/modules/company_api'
import { useRouter, useRoute } from 'vue-router'
import { useMapState } from '@/assets/js/use_storemap'
import tool from '@/assets/js/tool'
import msg from '@/utils/message'
import { ref, computed, watchEffect, watch } from 'vue'

const props = defineProps({
  whichInvoice: {
    type: String
  }, // vip 还是 gallery 开票
  type: {
    type: String,
    default: '1'
  }, // 1: 开具发票；2：发票详情
  showDialog: {
    type: Boolean
  },
  seeDetail: {
    type: Boolean
  }, // 发票详情?
  invoiceId: {
    type: String
  },
  orderType: {
    type: Number
  }, // 1: 360 开票；0: 普通类型开票；2: 联想 开票；
  curInvoiceType: {
    type: Number
  } // 父组件设置当前选中的“发票类型”
})
/*
  was_pass: 开票成功
*/
const emits = defineEmits(['update:showDialog', 'update:seeDetail', 'was_pass'])

const { Token } = useMapState({
  Token: state => state.user.token
})
const router = useRouter()
const route = useRoute()

const showLayoutDialog = computed({
  get() {
    return props.showDialog
  },
  set(newValue) {
    emits('update:showDialog', newValue)
  }
})
const seeDetail = computed({
  get() {
    return props.seeDetail
  },
  set(newValue) {
    emits('update:seeDetail', newValue)
  }
})

let aboutInvoice = ref({
  isPass: false, // 开具发票成功?
  loading: false
}) // 开具发票 还是 发票详情
const invoiceType = ref({
  value: 0,
  label: '数字化电子普票',
  options: [
    { value: 0, label: '数字化电子普票', isShow: true },
    { value: 1, label: '数字化电子专票', isShow: true }
  ]
}) // 发票类型
const invoiceHeadType = ref({
  value: 1,
  label: '企业单位',
  options: [
    { value: 1, label: '企业单位', isShow: true },
    { value: 2, label: '个人/非企业', isShow: true }
  ]
}) // 抬头类型

const required = ref([
  {
    id: 1,
    title: '发票抬头',
    value: '',
    placeholderTxt: '必填，请填写公司名称',
    isShow: true
  }, // isShow: 是否需要此条数据，true（需要）
  {
    id: 2,
    title: '企业税号',
    value: '',
    placeholderTxt: '必填，请填写纳税人识别号',
    isShow: true
  }
]) // 必填项
const generalTicket = ref([
  {
    id: 1,
    title: '备注',
    value: '',
    placeholderTxt: '选填，请输入备注',
    isShow: false
  }
]) // 普票专享
let aboutSpecial = ref({
  show: false,
  txt: '更多信息（填写地址电话、开户行和账号、备注说明等，非必填）'
})
const specialTicket = ref([
  {
    id: 1,
    title: '开户银行',
    value: '',
    placeholderTxt: '选填，请输入开户银行',
    beRequired: false, // 变为必填?
    isShow: true
  },
  {
    id: 2,
    title: '银行账号',
    value: '',
    placeholderTxt: '选填，请输入开户银行账号',
    beRequired: false, // 变为必填?
    isShow: true
  },
  {
    id: 3,
    title: '注册地址',
    value: '',
    placeholderTxt: '选填，请输入注册地址',
    beRequired: false,
    isShow: true
  },
  {
    id: 4,
    title: '注册电话',
    value: '',
    placeholderTxt: '选填，请输入注册电话',
    beRequired: false,
    isShow: true
  },
  {
    id: 5,
    title: '备注',
    value: '',
    placeholderTxt: '选填，请输入备注',
    beRequired: false,
    isShow: false
  }
]) // 专票专享
let receiveEamil = ref('') // 邮箱账号
let couldInvoice = ref(false) // 是否可以开具发票? true: 可
let limitFlag = ref(false) // 节流
const makeSure = ref({
  show: false
})

// 切换 "发票类型"
const selectInvoiceType = command => {
  invoiceType.value.value = command.value
  invoiceType.value.label = command.label

  const matchingItem = required.value.find(item => item.id == 2)
  if (invoiceType.value.value == 1) {
    if (!matchingItem.isShow) {
      matchingItem.isShow = true
    }
  } else {
    judgeRequiredItemShow()
  }
}

// 切换 "抬头类型"
const selectInvoiceHeadType = command => {
  invoiceHeadType.value.value = command.value
  invoiceHeadType.value.label = command.label

  judgeRequiredItemShow()
}

const judgeRequiredItemShow = () => {
  const matchingItem = required.value.find(item => item.id == 2)
  if (invoiceHeadType.value.value == 1) {
    if (!matchingItem.isShow) {
      matchingItem.isShow = true
    }
  } else {
    if (matchingItem.isShow) {
      matchingItem.isShow = false
    }
  }
}

const toOpenInvoice = () => {
  if (limitFlag.value) {
    msg.i({ msg: '提交填写信息中，请稍等', duration: 4000 })
    return
  }

  if (!couldInvoice.value) {
    msg.i({ msg: '请将必填项填写一下', duration: 4000 })
    return
  }

  if (!tool.checkEmail(receiveEamil.value)) {
    msg.i({ msg: '请仔细核对邮箱格式', duration: 4000 })
    return
  }

  if (
    !isOnlyNumSpaceDash(getSpecialTicketValue(4)) &&
    invoiceType.value.value == 1 &&
    props.orderType == 1
  ) {
    msg.i({ msg: '注册电话只能输入数字、空格和 “-”', duration: 4000 })
    return
  }

  makeSure.value.show = true
}

// const isAllNumber = str => {
//   const reg = /^\d+$/
//   // 先转字符串，避免数字类型、null、undefined报错
//   return reg.test(String(str))
// }

const makeSureConfirm = () => {
  makeSureCancel()
  limitFlag.value = true

  const cid = route.query.cid
  if (!cid && !tool.isAllDigits(cid)) return

  if (invoiceType.value.value == 0) {
    // 开普票
    openGeneralTicket(cid)
  } else {
    // 开专票
    openSpecialTicket(cid)
  }
}

const makeSureCancel = () => {
  makeSure.value.show = false
}

// 开普票
const openGeneralTicket = cid => {
  let tax = ''
  if (invoiceHeadType.value.value == 1) {
    tax = getRequiredValue(2)
  }
  let remarks = ''
  if (props.orderType != 1) {
    remarks = generalTicket.value.find(item => item.id == 1).value
  }

  apiUserInvoice({
    invoice_type: 1,
    type: props.whichInvoice,
    user_token: Token.value,
    collection_method: 1,
    phone: '',
    email: receiveEamil.value,
    title: getRequiredValue(1),
    tax,
    cid,
    bank: '',
    account: '',
    company_address: '',
    company_phone: '',
    qualify_path: '',
    title_type: invoiceHeadType.value.value,
    remarks
  }).then(res => {
    limitFlag.value = false
    if (res.code == 1) {
      aboutInvoice.value.isPass = true
      emits('was_pass', true)
    } else {
      msg.e({ msg: '开具发票失败，请稍后再试' })
    }
  })
}
// 开专票
const openSpecialTicket = cid => {
  let qualify = {
    kpzg_img_path: '',
    kpzg_yyzz_img_path: ''
  }
  let remarks = ''
  let company_phone = ''

  company_phone = getSpecialTicketValue(4)
  company_phone = clearDashAndSpace(company_phone)
  if (props.orderType == 1) {
    remarks = specialTicket.value.find(item => item.id == 5).value
    // 检查格式是否符合
    // if (remarks.includes('-')) {
    //   msg.i({ msg: '填写座机号时无需携带 “-”', duration: 4000 })
    //   limitFlag.value = false

    //   return false
    // }

    console.log(company_phone)
    if (company_phone == '') {
      msg.i({ msg: '请填写注册电话', duration: 4000 })
      limitFlag.value = false
      return false
    }
  }

  specialApiInvoice({
    invoice_type: 3,
    type: props.whichInvoice,
    user_token: Token.value,
    collection_method: 1,
    phone: '',
    email: receiveEamil.value,
    title: getRequiredValue(1),
    tax: getRequiredValue(2),
    cid,
    bank: getSpecialTicketValue(1),
    account: getSpecialTicketValue(2),
    company_address: getSpecialTicketValue(3),
    company_phone: company_phone,
    qualify_path: JSON.stringify(qualify),
    remarks
  }).then(res => {
    limitFlag.value = false
    if (res.code == 1) {
      aboutInvoice.value.isPass = true
      emits('was_pass', true)
    } else {
      msg.e({ msg: '开具发票失败，请稍后再试' })
    }
  })
}

function getRequiredValue(id) {
  return required.value.find(item => item.id == id).value
}
function getSpecialTicketValue(id) {
  return specialTicket.value.find(item => item.id == id).value
}

// 获取 "发票详情" 信息
const getOrderDetail = async () => {
  try {
    const res = await apiOrderSeeDetail({
      id: props.invoiceId,
      user_token: Token.value
    })

    if (res.code == 1) {
      const data = res.param1

      for (let k in data) {
        switch (k) {
          case 'invoice_type':
            {
              if (data[k] == '3') {
                // 数字化电子专票
                setInvoiceTypeOptions(1)
              } else if (data[k] == '1') {
                // 数字化电子普票
                setInvoiceTypeOptions(0)
              } else if (data[k] == '2') {
                // 纸质发票
                invoiceType.value.options.forEach(item => {
                  item.isShow = false
                })
              }
            }
            break
          case 'title_type':
            {
              if (data[k] == '2') {
                // 个人
                setInvoiceHeadType(2)
              } else {
                // 公司
                setInvoiceHeadType(1)
              }
            }
            break
          case 'title':
            // 发票抬头
            required.value.find(item => item.id == 1).value = data[k]
            break
          case 'tax':
            // 企业税号
            required.value.find(item => item.id == 2).value = removeAllSpace(data[k])
            break
          case 'company_phone':
            // 注册电话
            specialTicket.value.find(item => item.id == 4).value = data[k]
            break
          case 'company_address':
            // 注册地址
            specialTicket.value.find(item => item.id == 3).value = data[k]
            break
          case 'bank':
            // 开户银行
            specialTicket.value.find(item => item.id == 1).value = data[k]
            break
          case 'account':
            // 银行账号
            specialTicket.value.find(item => item.id == 2).value = formatBankCard(data[k])
            break
          case 'email':
            // 邮箱账号
            receiveEamil.value = data[k]
            break

          default:
            break
        }
      }
    } else {
      msg.e({ msg: '获取失败，请稍后再试' })
    }
  } catch (error) {
    console.log('Error:', error)
    msg.e({ msg: '出错了，请稍后再试' })
  } finally {
    setTimeout(() => {
      aboutInvoice.value.loading = false
    }, 500)
  }
}
function setInvoiceTypeOptions(id) {
  const obj = invoiceType.value.options.find(item => item.value == id)
  invoiceType.value.value = obj.value
  invoiceType.value.label = obj.label
  invoiceType.value.options.find(item => item.value != id).isShow = false
}
function setInvoiceHeadType(id) {
  const obj = invoiceHeadType.value.options.find(item => item.value == id)
  invoiceHeadType.value.value = obj.value
  invoiceHeadType.value.label = obj.label
  invoiceHeadType.value.options.find(item => item.value != id).isShow = false

  judgeRequiredItemShow()
}

const cancelHandle = () => {
  if (aboutInvoice.value.isPass) aboutInvoice.value.isPass = false
  emits('update:showDialog', false)
  emits('update:seeDetail', false)
  router.push({
    path: '/personal/orderinfo'
  })
}

// 删除非数字字符
const clearDashAndSpace = val => {
  return String(val).replace(/[-\s]/g, '')
}

//判断输入是否只包含 数字 空格 -
const isOnlyNumSpaceDash = str => {
  return /^[0-9 -]*$/.test(String(str))
}

watch(
  () => props.curInvoiceType,
  newVal => {
    invoiceType.value.value = newVal
    invoiceType.value.label = invoiceType.value.options.find(item => item.value == newVal).label
  },
  { immediate: true }
)

watch(
  () => props.invoiceId,
  (newVal, oldVal) => {
    if (newVal != oldVal) {
      if (seeDetail.value) {
        aboutInvoice.value.loading = true
        getOrderDetail()
      }
    }
  },
  { immediate: true }
)

// 监听条件是否满足开具发票按钮可点
watchEffect(() => {
  const iTitle = required.value.find(item => item.id == 1).value
  const iTax = required.value.find(item => item.id == 2).value

  if (invoiceType.value.value === 1) {
    // 开专票
    if (props.orderType == 1) {
      specialTicket.value.map(item => {
        if (item.id != 5) {
          item.beRequired = true
          item.placeholderTxt = '必填' + item.placeholderTxt.substring(2)
        } else {
          item.isShow = true
        }
      })
      aboutSpecial.value.show = true
      aboutSpecial.value.txt = '更多信息（填写地址电话、开户行和账号、备注说明等，必填）'

      let specialState = specialTicket.value.every(item => {
        // 跳过 id 为 5 的 item
        if (item.id === 5) {
          return true
        }
        // 检查其他 item 的 value 是否不为空
        return item.value != ''
      })

      if (iTitle && iTax && receiveEamil.value && specialState) {
        couldInvoice.value = true
      } else {
        couldInvoice.value = false
      }
    } else {
      if (iTitle && iTax && receiveEamil.value) {
        couldInvoice.value = true
      } else {
        couldInvoice.value = false
      }
    }
  } else if (invoiceType.value.value === 0) {
    // 开普票
    if (invoiceHeadType.value.value === 1) {
      // 企业
      if (iTitle && iTax && receiveEamil.value) {
        couldInvoice.value = true
      } else {
        couldInvoice.value = false
      }
    } else if (invoiceHeadType.value.value === 2) {
      // 个人/非企业
      if (iTitle && receiveEamil.value) {
        couldInvoice.value = true
      } else {
        couldInvoice.value = false
      }
    }

    if (props.orderType == 1) {
      generalTicket.value.find(item => item.id == 1).isShow = true
    }
  }
})

/**
 * 移除字符串全部空格
 * @param {string} str 原始字符串
 * @returns {string} 无空格文本
 */
function removeAllSpace(str) {
  return String(str).replace(/\s/g, '')
}

/**
 * 银行卡号格式化 每4位加空格
 * @param {string} cardNo 卡号（可带空格）
 * @returns {string} 格式化卡号 6222 0222 3333 4444
 */
function formatBankCard(cardNo) {
  // 先清除所有空格
  const pureNum = removeAllSpace(cardNo)
  // 每4位插入空格，末尾不生成多余空格
  return pureNum.replace(/(\d{4})(?=\d)/g, '$1 ')
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_make.scss';
@import '@/assets/scss/common.scss';

.invoice-dialog {
  :deep(.el-dialog.dialog-primary) {
    position: relative;
    margin-top: 17vh;
    @include responsive-style(
      (
        width: 539px
      )
    );

    .close_icon {
      position: absolute;
      cursor: pointer;
      @include responsive-style(
        (
          right: 10px,
          top: 9px,
          padding: 10px 15px
        )
      );

      &:hover {
        .svg-icon {
          color: $--themecolor;
        }
      }

      .svg-icon {
        color: #979797;
        @include responsive-style(
          (
            width: 16px,
            height: 16px
          )
        );
      }
    }

    .draw_invoice {
      color: #000;

      .dialog_tab {
        display: flex;
        align-items: center;
        user-select: none;
        @include responsive-style(
          (
            margin-bottom: 20px
          )
        );

        li {
          display: flex;
          align-items: center;
          cursor: pointer;
          @include responsive-style(
            (
              margin-right: 20px
            )
          );

          .select {
            @include responsive-style(
              (
                margin-right: 4px
              )
            );
          }
        }
      }

      .dialog_part2 {
        @include responsive-style(
          (
            margin-top: 16px
          )
        );

        .main_part1 {
          li {
            margin-bottom: 0;
          }
        }
      }

      .dialog_more-info {
        .main_title {
          padding-left: 0;
          font-weight: 400;
          color: #828282;
          cursor: pointer;
          user-select: none;

          &::before {
            display: none;
          }

          &.rotateSvg {
            .svg-icon {
              transform: rotate(180deg);
            }
          }

          .svg-icon {
            @include responsive-style(
              (
                width: 14px,
                height: 14px
              )
            );
          }
        }
      }

      .main_title {
        position: relative;
        font-weight: 500;
        @include responsive-style(
          (
            margin-bottom: 16px,
            padding-left: 9px
          )
        );

        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          background: #0396ff;
          @include responsive-style(
            (
              width: 3px,
              height: 17px
            )
          );
        }
      }

      .main_part1 {
        & > li {
          display: flex;
          align-items: center;
          @include responsive-style(
            (
              padding: 0 16px,
              margin-bottom: 12px
            )
          );

          .part_title {
            width: 19%;
            flex-shrink: 0;
            text-align: right;
            @include responsive-style(
              (
                margin-right: 6px
              )
            );
          }

          .part_selected {
            display: flex;
            align-items: center;

            li {
              display: flex;
              align-items: center;
              cursor: pointer;
              @include responsive-style(
                (
                  margin-right: 20px
                )
              );

              .select {
                @include responsive-style(
                  (
                    margin-right: 4px
                  )
                );
              }
            }
          }

          .part_input {
            .el-input__wrapper {
              padding: 0;
              background: #fff;
              @include responsive-style(
                (
                  box-shadow: 0 0 0 1px #d3d5da inset,
                  border-radius: 6px
                )
              );

              &.is-focus {
                box-shadow: 0 0 0 1px $--themecolor;
              }

              .el-input__inner {
                color: #000;
                @include responsive-style(
                  (
                    height: 32px,
                    padding: 4px 8px,
                    line-height: 32px,
                    font-size: 14px
                  )
                );
              }
            }
          }
        }

        .fill_more_info {
          gap: 0;
          padding: 0;
          margin: 16px 0;
          cursor: pointer;
          user-select: none;

          .toUp {
            transform: rotate(180deg);
            transition: transform 0.2s;
          }
        }
      }

      .essential {
        color: #f04343;
      }

      .select {
        position: relative;
        border-radius: 50%;
        @include responsive-style(
          (
            width: 14px,
            height: 14px,
            box-shadow: 0 0 0 1px rgba(211, 213, 218, 1) inset
          )
        );

        &.selected {
          @include responsive-style(
            (
              box-shadow: 0 0 0 1px #0396ff inset
            )
          );

          &::before {
            content: '';
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            border-radius: 50%;
            background-color: #0396ff;
            @include responsive-style(
              (
                width: 10px,
                height: 10px
              )
            );
          }
        }
      }

      .tip {
        color: #f04343;
        font-weight: 400;
        @include responsive-style(
          (
            margin-left: 33px
          )
        );
      }
    }

    .invoice_is_pass {
      text-align: center;

      .svg-icon {
        @include responsive-style(
          (
            margin-top: -20px,
            width: 224px,
            height: 186px
          )
        );
      }

      .main_title {
        font-weight: 700;
        color: #3a3d44;
        line-height: 1.5;
        @include responsive-style(
          (
            margin: 8px 0 10px,
            font-size: 20px
          )
        );
      }

      .intro {
        color: #979797;
        line-height: 1.5;
      }

      .back_home {
        display: block;
        color: #fff;
        line-height: 1.5;
        font-weight: 500;
        background: #0396ff;
        box-sizing: border-box;
        cursor: pointer;
        @include responsive-style(
          (
            width: 120px,
            padding: 10px 20px,
            margin: 24px auto 0,
            border-radius: 8px,
            font-size: 16px
          )
        );
      }
    }

    .dialog-footer {
      .el-button {
        @include responsive-style(
          (
            width: 68px
          )
        );

        &.is-disabled {
          border-color: #d3d5da;
          background-color: #d3d5da;
          opacity: 1;
        }
      }
    }
  }

  :deep(.make_sure) {
    @include responsive-style(
      (
        width: 400px,
        padding: 24px 20px,
        border-radius: 6px
      )
    );

    .el-dialog__header {
      padding: 0;
    }

    .el-dialog__headerbtn {
      @include responsive-style(
        (
          top: 15px,
          right: 20px,
          width: 36px,
          height: 36px,
          font-size: 16px
        )
      );

      &:hover {
        .el-dialog__close {
          color: $--themecolor;
        }
      }
    }

    .el-dialog__body {
      padding: 0;

      .dialog_contain {
        .main_title {
          display: flex;
          align-items: center;
          color: #1d1f24;
          font-weight: 500;
          @include responsive-style(
            (
              gap: 8px,
              font-size: 16px,
              line-height: 24px
            )
          );
        }

        .main_part {
          color: #000;
          @include responsive-style(
            (
              padding: 24px 0 20px,
              font-size: 14px
            )
          );
        }
      }
    }

    .el-dialog__footer {
      padding: 0;

      .el-button {
        color: #999;
        background-color: transparent;
        @include responsive-style(
          (
            height: 32px,
            padding: 6px 20px,
            border-radius: 4px,
            border: 1px solid #ced0d1,
            font-size: 14px,
            line-height: 20px
          )
        );
      }

      .el-button--primary {
        border-color: $--themecolor;
        color: #fff;
        background-color: $--themecolor;
      }

      .el-button + .el-button {
        @include responsive-style(
          (
            margin-left: 14px
          )
        );
      }
    }
  }
}
</style>
